module.exports = __webpack_public_path__ + "280b0350842b8b96e45b9582ede208ac.otf";